import getDefaultState from './moduleCastState.js';

export default {
  setInitialState(state) {
    Object.assign(state, getDefaultState());
  },
  // setCastList(state, payload) {
  //   state.casts = payload;
  // },
  // setCastDetails(state, { castId, details }) {
  //   state.castsInfo[castId] = details;
  // },
  ADD_CAST(state, payload) {
    state.casts.push(payload);
  },
  SET_RECORDING_LIST(state, payload){
    state.recordings = payload; 
  },
  SET_CASTS_INFO(state, castsInfo) {
    state.castsInfo = castsInfo;
  },
  SET_ALL_CASTS(state, payload) {
    state.casts = payload;
  },
  SET_RECORDINGLIST(state,payload){
    state.decastRecordings = payload; 
  },
  SET_RECORDING(state, { recording, videoUrl }) {
    state.recording = recording;
    state.videoUrl = videoUrl;
  },

  CLEAR_RECORDING(state) {
    state.recording = null;
    state.videoUrl = null;
  }
};
